export const KNOWLEDGE_BASE =
  'https://knowledge-base.yieldbird.com/yieldbird-platform/gam-api-connection#block-ee3416da97054c5596d2eb8b3d6a5fb0' as const
